export default __webpack_public_path__ + "static/media/wwf_small.0fdcc7ea.jpg";